import { removeUndefined } from '../utils/index.js';

type EmailTemplateKey = string; // TODO: Add the correct type
type EmailTemplateData = Record<string, unknown>; // TODO: Add the correct type

type TemplateData<TTemplate extends EmailTemplateKey> = TTemplate extends keyof EmailTemplateData
  ? EmailTemplateData[NoInfer<TTemplate>]
  : null;

type CreateEmailObjParams<TTemplate extends EmailTemplateKey, TData extends TemplateData<NoInfer<TTemplate>>> = {
  to: string;
  cc?: string | string[];
  bcc?: string | string[];
} & (
  | {
      template: TTemplate;
      data: TData;
    }
  | {
      message: string;
    }
);

export const createEmailObj = <TTemplate extends EmailTemplateKey, TData extends TemplateData<NoInfer<TTemplate>>>({
  to,
  cc,
  bcc,
  ...rest
}: CreateEmailObjParams<TTemplate, TData>) => {
  if ('template' in rest) {
    const { template, data } = rest;

    const emailObj = {
      to,
      cc,
      bcc,
      // FUTURE: Add these fields back in when we have a use case for them
      // toUids: null,
      // ccUids: null,
      // bccUids: null,
      // message: null,
      template: {
        name: template,
        ...(data ? { data } : {}),
      },
    };

    return removeUndefined(emailObj);
  }
  const { message } = rest;

  const emailObj = {
    to,
    cc,
    bcc,
    // FUTURE: Add these fields back in when we have a use case for them
    // toUids: null,
    // ccUids: null,
    // bccUids: null,
    message,
  };

  return removeUndefined(emailObj);
};
